
import "./src/css/fonts/Bebas/style.css";
import "./src/css/preloader/preloader.css";
import "./src/css/icons/fonts/icomoon/style.css";
import "./src/css/global.css";

export const onInitialClientRender = () => {
    setTimeout(function() {
        document.getElementById("preloader").style.display = "none";
    }, 1000)
}